
import './App.css';
import React from 'react';
import { AwesomeButton } from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import './button.scss';

function Checksum(s) {
  // TODO: Filter out invalid inputs
  let arr = []; // length of 6
  let mult = [14, 2, 12, 2, 11, 1];
  let letters = ['A', 'Y', 'U', 'S', 'P', 'L', 'J', 'G', 'D', 'B', 'Z', 'X', 'T', 'R', 'M', 'K', 'H', 'E', 'C'];

  const alphaVal = (s) => s.toLowerCase().charCodeAt(0) - 97 + 1
  const isLetter = (c) => !(c >= '0' && c <= '9');

  let contdex = 0;

  if ((isLetter(s[s.length - 1]) && isLetter(s[s.length - 2])) || (isLetter(s[0]) && isLetter(s[1]) && isLetter(s[2]) && isLetter(s[3])) || (!isLetter(s[0]))){
    return 'Invalid input';
  }

  // edge cases:
  // 1. more than 3 letters at the start
  // 2. more than 4 numbers at the end
  // 3. number in the middle

  for (let i = 0; i < s.length; i++) {
    if (isLetter(s[i])) {
      if (i > 2 && i !== s.length - 1) return 'Invalid input';
    }
  }

  if (s.length === 8 && !isLetter(s[7])) return 'Invalid input';

  if (isLetter(s[1])) {
    if (isLetter(s[2])) {
      arr.push(alphaVal(s[1]));
      arr.push(alphaVal(s[2]));
      contdex = 3;
    } else {
      arr.push(alphaVal(s[0]));
      arr.push(alphaVal(s[1]));
      contdex = 2;
    }
  } else {
    arr.push(0);
    arr.push(alphaVal(s[0]));
    contdex = 1;
  }

  let count = 0;
  while (!isLetter(s[contdex + count])) count++;
  for (let i = 0; i < 4 - count; i++) arr.push(0);
  for (let i = 0; i < count; i++) arr.push(s[contdex + i]);

  let ans = 0;
  for (let i = 0; i < 6; i++) ans += arr[i] * mult[i];

  if (isLetter(s[s.length - 1])) {
    return (s.substring(0, s.length - 1) + letters[ans % 19]);
  }
  return(s + letters[ans % 19]);
}

var htmlToImage = require('html-to-image');

function App() {
  const [showError, setShowError] = React.useState(false);
  return (
    <>
    <title>Singapore Vehicle Registration Nmber (VRN) Checksum</title>
    <div className="App">
      <h1>SG Car Plate Generator and Checksum</h1>
      <div id="download" className='download' ><input type="text" id='maininput' className="maininput" maxLength="8" placeholder='SGD123A'
      onKeyDown={event => {
        if (event.key === 'Enter') {
          let input = document.getElementById('maininput').value;
          let out = Checksum(input);
          if (out === 'Invalid input') {
            setShowError(true);
          } else {
            document.getElementById('maininput').value = out;
            setShowError(false);
          }
        }
      }}/></div>
    </div>
    <div className='button-container'>
      <AwesomeButton type='primary' className='checksumButton' onMouseDown={
      () => {
        let input = document.getElementById('maininput').value;
        let out = Checksum(input);
        if (out === 'Invalid input') {
          setShowError(true);
        } else {
          document.getElementById('maininput').value = out;
          setShowError(false);
        }
      }} style={{"margin-right": 10}}>Run Checksum</AwesomeButton>
      <AwesomeButton type='primary' onMouseDown={downloadImage}>Download Image</AwesomeButton>
    </div>
    <div className='errormessage'>
      {showError ? <h3>Invalid input! Please try again.</h3> : <h3>&nbsp;</h3>}
    </div>
    </>
  );
}

function downloadImage() {
  htmlToImage.toPng(document.getElementById('download'))
  .then((dataUrl) => {
    const link = document.createElement("a");
    link.download = 'plate.png';
    link.href = dataUrl;
    link.click();
  }).catch((err) => {
    console.log(err);
  });
}

export default App;